export default __webpack_public_path__ + "static/media/ds-app-icon.bc19d67b.png";